import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, ErrorForm, InputForm } from '../../components'
import { useForm, Controller } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { recoveryCodeSchema } from '../../yup'
import { IAuthRecoveryCode } from '../../interfaces'
import logo from '../../assets/images/logo.png'
import { errorHandler } from '../../services'
import { AuthService } from '../../services/index'
import { toast } from 'react-toastify'

export default function RecoveryCode(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const location = useLocation()
    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthRecoveryCode>({
        resolver: useYupValidation(recoveryCodeSchema),
    })

    async function sendRecoveryCode(values: IAuthRecoveryCode): Promise<void> {
        setIsLoading(true)
        try {
            await AuthService.sendRecoveryCode({ ...values, email: location.state })
            navigate('/reset-password', { state: { ...values, email: location.state } })
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div id="recovery-code__form">
            <div className="recovery-code__backgound">
                <div className="recovery-code__content">
                    <div className="recovery-code__images">
                        <img src={logo} alt="Logo CNA construtora" className="recovery-code__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Um código de recuperação foi enviado para:</h4>
                    <p className="recovery-email">{location.state}</p>
                    <form className="recovery-code__inputs" onSubmit={handleSubmit(sendRecoveryCode)}>
                        <Controller
                            name="code"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputForm label="Digite o código" placeholder="Digite o código" name="code" value={value} onChange={onChange} />
                                )
                            }}
                        />
                        <ErrorForm error={errors.code?.message} />
                        <div className="box-button-recovery">
                            <Button type={'button'} placeholder="Cancelar" onClick={() => navigate('/')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Recuperar senha" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
